import { defineMessages } from '../../i18n/messages';

export const HeroMessages = defineMessages({
  TITLE: {
    id: 'homepage.hero.title',
    text: 'Localize Your App in One Command, Not One Sprint',
    description: 'Primary headline displayed prominently at the top of the homepage. It contrasts the speed of Localingos (one CLI command) with the traditional slow process (an entire sprint). Should feel bold and confident. "Sprint" refers to an agile development cycle, typically 2 weeks.',
  },
  SUBTITLE: {
    id: 'homepage.hero.subtitle',
    text: 'Install the CLI. Run one command. Your app speaks 56 languages.',
    description: 'Secondary headline directly below the main title. Three short sentences that describe the workflow: install, run, done. "56 languages" is the number of supported locales. Keep the three-sentence rhythm. The last sentence should use an imperative or optative mood (like a wish/command: "let your app speak 56 languages") rather than a plain declarative statement.',
  },
  PROOF_JOBS_FINISH: {
    id: 'homepage.hero.proof_jobs_finish',
    text: 'Most jobs finish in seconds',
    description: 'Short trust badge shown near the hero section. Communicates that translation jobs complete very quickly, typically within a few seconds. Keep concise.',
  },
  PROOF_TRANSLATIONS_MIN: {
    id: 'homepage.hero.proof_translations_min',
    text: '1,000+ translations/min',
    description: 'Short trust badge showing throughput. Means the system can produce over 1,000 translated strings per minute. The "+" means "more than". Keep the number and unit format.',
  },
  PROOF_NO_SUBSCRIPTIONS: {
    id: 'homepage.hero.proof_no_subscriptions',
    text: 'Free forever, 5,000 words',
    description: 'Short trust badge about the free tier. Communicates that the free plan never expires and includes 5,000 translated words at no cost. Keep concise.',
  },
  BTN_START_TRANSLATING: {
    id: 'homepage.hero.btn_start_translating',
    text: 'Start Free, 5,000 Words Included',
    description: 'Label for the primary call-to-action button in the hero section. Clicking this takes the user to the sign-up page. Emphasizes that getting started is free and includes 5,000 words of translation.',
  },
  BTN_START_TRANSLATING_ARIA: {
    id: 'homepage.hero.btn_start_translating_aria',
    text: 'Start localizing your app for free',
    description: 'Screen reader accessible label for the primary call-to-action button. Should clearly describe the action: signing up to start translating an application at no cost.',
  },
  NO_CARD_REQUIRED: {
    id: 'homepage.hero.no_card_required',
    text: 'No credit card required',
    description: 'Short reassurance line shown directly beneath the primary sign-up button in the hero section. Confirms that creating an account and starting the free tier needs no payment details. Keep it short — it renders as a single small line of text.',
  },
  BTN_SEE_HOW: {
    id: 'homepage.hero.btn_see_how',
    text: 'See How It Works',
    description: 'Label for the secondary call-to-action button in the hero section. Clicking this scrolls the page down to the "How It Works" section. Should invite curiosity.',
  },
  BTN_SEE_HOW_ARIA: {
    id: 'homepage.hero.btn_see_how_aria',
    text: 'See how Localingos works',
    description: 'Screen reader accessible label for the secondary button. Should describe that clicking will show an explanation of how the Localingos product works.',
  },
});
